<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    title="Datenexport - Check-Ins"
    iconPath="assets/icons/identification-card.svg"
  />

  <mat-dialog-content class="pt-5 h-dvh">
    <p class="text-gray-600 mb-5 text-base leading-6">
      Lege den gewünschten Zeitraum fest und starte den Export. Der Datenexport wird dir
      anschließend als CSV-Datei per E-Mail zugestellt.
    </p>

    <mat-form-field class="w-full">
      <mat-label>Zeitraum angeben</mat-label>
      <mat-date-range-input
        [formGroup]="range"
        [rangePicker]="picker"
      >
        <input
          matStartDate
          formControlName="start"
          placeholder="Start"
        />
        <input
          matEndDate
          formControlName="end"
          placeholder="Ende"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      @if (range.controls.start.hasError('matStartDateInvalid')) {
        <mat-error>Invalid start date</mat-error>
      }
      @if (range.controls.end.hasError('matEndDateInvalid')) {
        <mat-error>Invalid end date</mat-error>
      }
    </mat-form-field>

    @if (alert) {
      <app-alert
        [message]="alert.message"
        [type]="alert.type"
      />
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="w-full">
      <app-button
        text="Export anfordern"
        [fullWidth]="true"
        [disabled]="range.invalid"
        [isLoading]="requestState() === RequestStateEnum.PENDING"
        (clicked)="triggerDataExport()"
      />
    </div>
  </mat-dialog-actions>
</div>
